import * as React from 'react';
import { Text, Button, tokens } from '@hotjar/hotsauce';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';

const Wrapper = styled.div`
  max-width: 100%;
  margin: ${tokens.spacer.x7} auto ${tokens.spacer.x2};
  padding: 0 ${tokens.spacer.x3};
  text-align: center;

  @media ${tokens.breakpoint.minWidth.m} {
    max-width: 632px;
  }
`;

const Title = styled(Text)`
  ${tokens.text('header4')};
  color: ${tokens.color.text_default};
  margin-bottom: ${tokens.spacer.x4};
  overflow: initial;
  white-space: initial;

  @media ${tokens.breakpoint.minWidth.s} {
    ${tokens.text('header2')};
  }
`;

const StyledButton = styled(Button)`
  margin-top: ${tokens.spacer.x4};
`;

export const EmailExistsScreen = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <Title as="h1">{t('common:registration.from-invite.email-exists.title')}</Title>
      <Text as="p" textType="body1" textColor="text_light">
        {t('common:registration.from-invite.email-exists.subtitle')}
      </Text>
      <StyledButton as="a" href="/login">
        {t('common:registration.from-invite.email-exists.button')}
      </StyledButton>
    </Wrapper>
  );
};
